<template>
    
    <div :id="modalId" ref="modal" data-modal-container tabindex="-1" 
        class="fixed top-0 left-0 right-0 z-[100] hidden w-full p-1 overflow-x-hidden overflow-y-auto md:inset-0 h-full max-h-full bg-black/50 backdrop-blur-sm"
        :class="props.class">
        <div :class="sizeClass[currentSize]">
            <!-- Modal content -->
            <div class="flex flex-col relative bg-white dark:bg-gray-800 rounded-2xl border border-gray-100 dark:border-gray-700 shadow-2xl" :class="{'h-full': currentSize=='fullscreen'}">
                <!-- Modal header -->
                <div class="flex items-center justify-between p-4 md:p-5 rounded-t border-b border-gray-100 dark:border-gray-700 shrink-0">
                    <h3 class="text-xl font-bold text-gray-900 dark:text-white" :class="titleClass">
                        <div>{{getTitle(props.title)}}</div>
                    </h3>
                    <div class="flex items-center ms-auto">
                        <slot name="header-actions"></slot>
                        <button @click="close()" type="button" class="text-gray-400 bg-transparent hover:bg-gray-100 hover:text-gray-900 rounded-lg text-sm w-8 h-8 inline-flex justify-center items-center dark:hover:bg-gray-700 dark:hover:text-white transition-colors duration-150 cursor-pointer ml-2">
                            <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                            </svg>
                            <span class="sr-only">Close modal</span>
                        </button>
                    </div>
                </div>
                <!-- Modal body -->
                <div data-modal-body class="p-5 space-y-4 overflow-y-auto" :class="{'flex-1 min-h-0 h-full max-h-full': currentSize=='fullscreen','h-[calc(100%-300px)] max-h-[calc(100%-300px)]': currentSize!='fullscreen'}">
                    <slot>
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { defineProps, defineExpose, onMounted, onUnmounted, ref, defineEmits } from "vue";
import { Modal } from "flowbite"
const modal = ref(null);
const modalId = ref(`modal-${Math.random().toString(36).substring(2, 9)}`);
let modalElement = ref(null);
let isOpen = ref(false);
let currentSize = ref('medium')
let sizeClass = {
    'small': 'relative w-full max-w-xl max-h-full',
    'medium': 'relative w-full max-w-2xl max-h-full',
    'large': 'relative w-full max-w-4xl max-h-full',
    'extra': 'relative w-full h-full max-w-7xl max-h-full',
    'fullscreen': 'relative w-full h-full max-w-7xl max-h-full'
}
let props = defineProps(['title', 'size', 'class'])
const emit = defineEmits(['close']);

let titleClass = ref("")

const getBackdropClasses = () => {
    if (props.class && props.class.includes('z-[500]')) {
        return "bg-black/60 backdrop-blur-sm fixed inset-0 z-[490]";
    }
    if (props.class && props.class.includes('z-[300]')) {
        return "bg-black/50 backdrop-blur-sm fixed inset-0 z-[290]";
    }
    return "bg-black/50 backdrop-blur-sm fixed inset-0 z-[90]";
};

const initModalElement = () => {
    if (!modal.value) return;
    if (!modalElement.value) {
        modalElement.value = new Modal(modal.value, {
            placement: 'enter',
            backdrop: 'static',
            backdropClasses: getBackdropClasses(),
            onShow: () => {
                isOpen.value = true;
            },
            onHide: () => {
                isOpen.value = false;
                emit('close');
            }
        });
    }
};

onMounted(() => {
    if (props.size && sizeClass[props.size]) {
        currentSize.value = props.size;
    }
    initModalElement();
});

onUnmounted(() => {
    if (isOpen.value) {
        close();
    }
    const backdrops = document.querySelectorAll('[modal-backdrop]');
    backdrops.forEach(b => b.remove());
    document.body.classList.remove('overflow-hidden');
});

const open = () => {
    if (!modalElement.value) {
        initModalElement();
    }
    isOpen.value = true;
    modalElement.value?.show();
};

const close = () => {
    if (!isOpen.value) return;
    isOpen.value = false;
    modalElement.value?.hide();
};

const size = (s) => {
    if (sizeClass[s]) {
        currentSize.value = s;
    }
}

const getTitle = (title) => {
    if (typeof(title)=='string') {
        return title;
    } else {
        titleClass.value = title.class;
        return title.value;
    }
}

defineExpose({open, close, size})


</script>